import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import * as filters from '@/libs/filters'
import components from '@/components/index'

import '@/assets/style/reset.css'
import '@/assets/style/common.scss'
import '@/assets/style/style.css'
import ElementUI from 'element-ui'

// 权限控制
import '@/utils/permission'

// ElementUI样式控制
import '@/utils/element'

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as any)[key])
})

// register global components
Vue.use(components)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
